module.exports = __webpack_public_path__ + "img/ServicesAndCountedServices.deff164b.svg";